<template>
  <div>
    <div class="mb-5 roster-heading">
      <div class="font-weight-bold">Do Not Suggest Vendors</div>
      <span class="font-italic font-weight-light d-block">Vendors added here will be removed from the 86 mix, and won't be suggested during dispatch.</span>
      <v-chip v-for="vendor in inheritedExcludedVendors" :key="vendor.id" class="mr-2 mb-2">{{vendor.name}}</v-chip>
    </div>
    <v-row v-for="(item, i) in updatedRoster" :key="item.id" align="center" class="mb-5 ml-10">
      <v-col cols="auto">
        <b>{{ i + 1 }}</b>
      </v-col>
      <v-col>
        <v-autocomplete
          :loading="!vendorsForCategory"
          outlined
          hide-details
          :items="vendorsForCategory"
          item-text="name"
          item-value="id"
          :value="item.vendorId"
          return-object
          :disabled="isSaving || disabled"
          @change="saveInput($event, i)">
        </v-autocomplete>
      </v-col>
      <v-col class="delete-column">
        <v-tooltip bottom v-if="item.vendorId">
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <EsButtonIcon
                icon="mdi-delete"
                aria-label="Remove Vendor From List"
                :disabled="isSaving || disabled"
                @click="removeVendor(item.vendorId)" />
            </span>
          </template>
          <span>Remove Vendor From List</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <EsButtonAction
      label="Add Vendor"
      icon="mdi-plus-circle-outline"
      class="add-vendor-button"
      :disabled="hasEmptySlot || isSaving || disabled"
      @click="addNewVendorSlot()" />
  </div>
</template>

<script>
import { EsButtonAction, EsButtonIcon } from "@86-repairs/design-system";

export default {
  name: 'EsVendorRosterExcludedSlots',
  components: {
    EsButtonAction,
    EsButtonIcon,
  },
  props: {
    roster: {
      type: Array,
      default: () => [],
    },
    inheritedExcludedVendors: {
      type: Array,
      default: () => [],
    },
    assetId: {
      type: String,
    },
    categoryId: {
      type: String,
    },
    vendorsForArea: {
      type: Array,
      default: () => [],
    },
    isSaving: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    updatedRoster: [],
  }),
  computed: {
    hasEmptySlot() {
      return this.updatedRoster?.filter((item) => !item.vendorId).length > 0;
    },
    vendorsForCategory() {
      return this.vendorsForArea.filter((vendor) => vendor.serviceCategoryIds?.includes(this.categoryId));
    },
  },
  mounted() {
    this.updatedRoster = [...this.roster];
  },
  watch: {
    roster() {
      this.updatedRoster = [...this.roster];
    },
    categoryId() {
      this.resetNewSlot();
    },
    assetId() {
      this.resetNewSlot();
    },
  },
  methods: {
    addNewVendorSlot() {
      if (this.updatedRoster?.length === 0 || !this.hasEmptySlot) {
        this.updatedRoster.push({});
      }
    },
    resetNewSlot() {
      this.updatedRoster = this.updatedRoster.filter((item) => item.vendorId);
    },
    saveInput(option, index) {
      this.updatedRoster[index] = {
        'vendorId': option.id,
      };
      this.saveRoster(this.updatedRoster);
      this.resetNewSlot();
    },
    removeVendor(vendorId) {
      this.updatedRoster = this.updatedRoster.filter((item) => item.vendorId !== vendorId);
      this.saveRoster(this.updatedRoster);
    },
    saveRoster(roster) {
      const payload = [{ excluded: true, roster: roster }];
      payload[0].categoryId = this.categoryId;
      payload[0].assetId = this.assetId;
      this.$emit('saveRoster', payload);
    },
  }
};
</script>

<style scoped>
.roster-heading {
  padding-left: 85px;
}
.delete-column {
  max-width: 170px;
  padding-right: 60px;
}
.add-vendor-button {
  margin-left: 85px;
  margin-bottom: 20px;
}
</style>